import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button, Checkbox, FormControlLabel, IconButton, InputAdornment, Popover, TableSortLabel, Typography, TextField } from "@mui/material";
import { useHistory } from "react-router-dom";
import { convertEpochToDate } from "../../../utils";
import DialogContentModal from "../../../../../templates/ApplicationDetails/components/DialogContent";
import TakeActionItem from "../../../../../templates/Forms/TakeActionItem";
import ApplicationView12 from "../../../../../templates/Forms/Form12/Application12View";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import TablePagination from "@mui/material/TablePagination";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableHeader: {
    backgroundColor: "#225785",
    borderBottom: "2px solid #ddd",
  },
  tableCell: {
    textAlign: "center",
    padding: "10px 15px",
    fontWeight: "bold",
    borderRight: "1px solid #ddd",
  },
  lastTableCell: {
    borderRight: "none",
  },
  whiteText: {
    color: "#ffffff",
  },
});

const matchesSearch = (value, search) => {
  if (!value) return false;
  return value.toString().toLowerCase().includes(search.toLowerCase());
};

const InboxTableLTR = ({ scrutinyDetails }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [smShow, setSmShow] = useState(false);
  const [smShowMs, setSmShowMs] = useState(false);
  const [idData, setIdData] = useState("");
  const [formType, setFormType] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [filters, setFilters] = useState({
    name: "",
    emailId: "",
    applicationNumber: "",
    status: "",
    applicationDate: "",
  });
  const [selectedColumns, setSelectedColumns] = useState([
    "srNo",
    "name",
    "emailId",
    "applicationNumber",
    "applicationDate",
    "status",
    "paymentReceipt",
    "approvalLetter",
  ]);
  const handleTakeAction = (item) => {
    console.log("itemFromTakeAction", item, item?.businessService);
    switch (item?.businessService) {
      case "BPAREG":
        history.push(`/digit-ui/employee/obps/professional/${item?.applicationNumber}`);
        break;
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item?.applicationNo}`);
        // handleClose();
        break;
      case "BPA_FAR_DA":
      case "BPA_FAR_AVP":
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item?.applicationNo}`);
        // handleClose();
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item?.applicationNo}`);
        // handleClose();
        break;
    }
    // setAnchorEl(false);
  };
  function getApprovalLetter(item) {
    const pdfUrl = item?.additionalDetails?.approvalLetterUrl;
    window.open(pdfUrl, "_blank");
  }
  // Table column definitions
  const allColumns = [
    {
      id: "srNo",
      label: t("FASTPAS.GLOBAL.SERIALNUMBER"),
      filterable: false,
      sortable: false,
      render: (item, index) => <TableCell>{page * rowsPerPage + index + 1}</TableCell>,
    },
    {
      id: "name",
      label: "Name",
      filterable: true,
      sortable: true,
      render: (item) => <TableCell>{item?.additionalDetails?.tradeLicenseDetail?.owners?.[0]?.name || "-"}</TableCell>,
    },
    {
      id: "emailId",
      label: "Email",
      filterable: true,
      sortable: true,
      render: (item) => <TableCell>{item?.additionalDetails?.tradeLicenseDetail?.owners?.[0]?.emailId || "-"}</TableCell>,
    },
    {
      id: "applicationNumber",
      label: "Application/Ref.No",
      filterable: true,
      sortable: true,
      render: (item) => (
        <TableCell>
          <strong style={{ color: "#007bff", textDecoration: "none", cursor: "pointer" }} onClick={() => handleTakeAction(item)}>
            {item?.applicationNumber || "-"}
          </strong>
        </TableCell>
      ),
    },
    {
      id: "applicationDate",
      label: "Applied On",
      filterable: false,
      sortable: true,
      render: (item) => <TableCell>{convertEpochToDate(item?.additionalDetails?.auditDetails?.createdTime) || "-"}</TableCell>,
    },
    {
      id: "status",
      label: "Pending Status",
      filterable: true,
      sortable: true,
      render: (item) => <TableCell>{t(`WF_BPA_MAP_${item?.additionalDetails?.status}`) || "-"}</TableCell>,
    },
    {
      id: "paymentReceipt",
      label: t("FASTPAS.GLOBAL.PAYMENT.RECIEPT.TEXT"),
      filterable: false,
      sortable: false,
      render: (item) => (
        <td className="td-receipt">
          {item?.additionalDetails?.registrationType !== "Architect" &&
            (item?.status === "APPROVED" ||
              item?.status === "APPLY_FOR_DSC" ||
              item?.status === "FORWARD_TO_ND_OFF_AWAS" ||
              item?.status === "FORWARD_TO_NODAL") ? (
            <Button
              size="small"
              className="btn-table-action"
              variant="contained"
              color="primary"
              onClick={() => {
                history.push({
                  pathname: `/digit-ui/citizen/obps/tradelicence/payment/${item?.applicationNumber}/up`,
                });
              }}
            >
              <span>Receipt</span>
            </Button>
          ) : (
            "N/A"
          )}
        </td>
      ),
      width: "10%",
    },
    {
      id: "approvalLetter",
      label: t("FASTPAS.GLOBAL.APPROVAL.LETTER"),
      filterable: false,
      sortable: false,
      render: (item) => (
        <td className="td-approval">
          {(item?.status === "APPROVED" || item?.status === "APPLY_FOR_DSC") && (
            <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getApprovalLetter(item)}>
              <span>View</span>
            </Button>
          )}
        </td>
      ),
      width: "10%",
    },
    // {
    //   id: "action",
    //   label: "Action",
    //   filterable: false,
    //   sortable: false,
    //   render: (item) => (
    //     <TableCell>
    //       <Button
    //         size="small"
    //         sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex" }}
    //         variant="contained"
    //         color="success"
    //         onClick={() => closeModal2(item)}
    //       >
    //         <span>View Application</span>
    //       </Button>
    //     </TableCell>
    //   ),
    // },
  ];

  const columns = allColumns.filter((col) => selectedColumns.includes(col.id));

  function closeModal2(item) {
    if (item?.serviceType === "FORM_11") {
      setIdData(item?.applicationNumber);
      setFormType("form11");
      if (item?.applicationNumber != null) {
        setSmShow(true);
      }
    } else if (item?.serviceType === "FORM_12") {
      setIdData(item?.applicationNumber);
      setFormType("form12");
      if (item?.applicationNumber != null) {
        setSmShowMs(true);
      }
    } else if (item?.serviceType === "FORM_26") {
      setIdData(item?.applicationNumber);
      setFormType("form26");
      if (item?.applicationNumber != null) {
        setSmShow(true);
      }
    }
  }

  // Sorting
  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Filtering and sorting
  const getFilteredAndSortedData = () => {
    let filteredData = scrutinyDetails?.ApplicationData || [];

    // Global search
    if (globalSearch) {
      filteredData = filteredData.filter(
        (item) =>
          matchesSearch(item?.name, globalSearch) ||
          matchesSearch(item?.additionalDetails?.landInfo?.owners?.[0]?.emailId, globalSearch) ||
          matchesSearch(item?.applicationNumber, globalSearch) ||
          matchesSearch(t(`WF_BPA_MAP_${item?.additionalDetails?.status}`), globalSearch) || // FIX: use translated status
          matchesSearch(convertEpochToDate(item?.additionalDetails?.auditDetails?.createdTime), globalSearch)
      );
    }

    // Column filters
    if (filters.name) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.name, filters.name));
    }
    if (filters.emailId) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.additionalDetails?.landInfo?.owners?.[0]?.emailId, filters.emailId));
    }
    if (filters.applicationNumber) {
      filteredData = filteredData.filter((item) => matchesSearch(item?.applicationNumber, filters.applicationNumber));
    }
    if (filters.status) {
      filteredData = filteredData.filter(
        (item) => matchesSearch(t(`WF_BPA_MAP_${item?.additionalDetails?.status}`), filters.status) // FIX: use translated status
      );
    }

    // Sorting
    filteredData.sort((a, b) => {
      let aValue, bValue;
      switch (orderBy) {
        case "name":
          aValue = a?.name?.toLowerCase() || "";
          bValue = b?.name?.toLowerCase() || "";
          break;
        case "emailId":
          aValue = a?.additionalDetails?.landInfo?.owners?.[0]?.emailId?.toLowerCase() || "";
          bValue = b?.additionalDetails?.landInfo?.owners?.[0]?.emailId?.toLowerCase() || "";
          break;
        case "applicationNumber":
          aValue = a?.applicationNumber?.toLowerCase() || "";
          bValue = b?.applicationNumber?.toLowerCase() || "";
          break;
        case "status":
          aValue = t(`WF_BPA_MAP_${a?.additionalDetails?.status}`)?.toLowerCase() || "";
          bValue = t(`WF_BPA_MAP_${b?.additionalDetails?.status}`)?.toLowerCase() || "";
          break;
        case "applicationDate":
          aValue = a?.additionalDetails?.auditDetails?.createdTime || 0;
          bValue = b?.additionalDetails?.auditDetails?.createdTime || 0;
          break;
        default:
          aValue = "";
          bValue = "";
      }
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    });

    return filteredData;
  };

  const filteredAndSortedData = getFilteredAndSortedData();
  const paginatedData = filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  // Column filter popover
  const handleOpenColumnFilter = (event) => setAnchorEl(event.currentTarget);
  const handleCloseColumnFilter = () => setAnchorEl(null);

  const handleColumnToggle = (columnId) => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter((id) => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };

  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value,
    });
    setPage(0);
  };

  const handleClearFilter = (property) => {
    setFilters({
      ...filters,
      [property]: "",
    });
  };

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <React.Fragment>
      <TableContainer className="table-container">
        <div className="emp-global-search">
          <Button
            variant="outlined"
            startIcon={<FilterListIcon />}
            onClick={handleOpenColumnFilter}
            size="small"
            sx={{
              height: "27px",
              fontSize: "12px",
              borderColor: "rgb(31, 74, 124)",
              color: "rgb(31, 74, 124)",
            }}
          >
            {t("FASTPAS.GLOBAL.FILTERS.TEXT")}({selectedColumns.length === allColumns.length ? "All" : selectedColumns.length}){" "}
          </Button>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search here..."
            value={globalSearch}
            onChange={(e) => setGlobalSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ background: "#1f4a7c", color: "#fff", height: "24px", borderRadius: "7px 0px 0px 7px", width: "29px" }} />
                </InputAdornment>
              ),
              endAdornment: globalSearch && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setGlobalSearch("")}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              padding: "0px",
              height: "25px",
              "& .MuiInputBase-root": {
                height: "27px",
                padding: "0px",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgb(31, 74, 124)",
              },
              "& .MuiOutlinedInput-input": {
                padding: "0",
                fontSize: "12px",
              },
            }}
          />
        </div>
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleCloseColumnFilter}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <div className="select-column-popover">
            <Typography variant="subtitle2" gutterBottom>
              Select Columns to Display
            </Typography>
            {allColumns.map((column) => (
              <div key={column.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      sx={{ padding: "0px" }}
                      checked={selectedColumns.includes(column.id)}
                      onChange={() => handleColumnToggle(column.id)}
                      disabled={column.id === "srNo" && selectedColumns.length === 1}
                    />
                  }
                  sx={{ margin: "0px" }}
                  label={column.label}
                />
              </div>
            ))}
          </div>
        </Popover>
        <Table className="application-table" aria-label="applied data tabular format">
          <thead>
            <tr>
              {columns.map((column) => (
                <th display="flex" alignItems="center">
                  {column.label}
                  {column.sortable && (
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={() => handleSort(column.id)}
                      sx={{
                        color: "white !important",
                        "& .MuiTableSortLabel-icon": {
                          opacity: "1 !important",
                          color: "white !important",
                        },
                        "&:hover": {
                          color: "white !important",
                        },
                      }}
                    />
                  )}
                </th>
              ))}
            </tr>
            <tr>
              {columns.map((column) => (
                <td key={column.id}>
                  {column.filterable && (
                    <TextField
                      variant="standard"
                      size="small"
                      value={filters[column.id] || ""}
                      onChange={(e) => handleFilterChange(column.id, e.target.value)}
                      InputProps={{
                        endAdornment: filters[column.id] && (
                          <InputAdornment position="end">
                            <IconButton size="small" onClick={() => handleClearFilter(column.id)} sx={{ color: "white" }}>
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiInput-input": {
                          color: "black !important",
                          fontSize: "0.75rem",
                        },
                        width: "100%",
                      }}
                    />
                  )}
                </td>
              ))}
            </tr>
          </thead>
          <TableBody>
            {paginatedData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No records found
                </TableCell>
              </TableRow>
            ) : (
              paginatedData.map((item, index) => <TableRow key={index}>{columns.map((column) => column.render(item, index))}</TableRow>)
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={filteredAndSortedData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </TableContainer>
      <DialogContentModal title={"Application Details"} dataOpen={smShow} onClose={() => setSmShow(false)}>
        <TakeActionItem id={idData} formType={formType} />
      </DialogContentModal>
      <DialogContentModal title={"Application Details"} dataOpen={smShowMs} onClose={() => setSmShowMs(false)}>
        <ApplicationView12 id={idData} formType={formType} />
      </DialogContentModal>
    </React.Fragment>
  );
};

export default InboxTableLTR;
